import { sectionRenderer } from '@theme/section-renderer';

const SECTION_ID = 'cart-drawer-section';

async function postCart(url, body) {
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart update failed');
  return data;
}

async function refresh() {
  await sectionRenderer.renderSection(SECTION_ID, { cache: false });
  const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  document.querySelectorAll('cart-icon').forEach((icon) => {
    if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count, false);
  });
  initPromo();
}

function initPromo(root = document) {
  root.querySelectorAll('[data-dama-cart-promo]').forEach((promo) => {
    const progress = Math.max(0, Math.min(100, Number(promo.dataset.progress) || 0));
    requestAnimationFrame(() => promo.style.setProperty('--dc-progress', `${progress}%`));
  });
}

document.addEventListener('click', async (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  const qty = target.closest('[data-dama-cart-qty]');
  const remove = target.closest('[data-dama-cart-remove]');
  const protect = target.closest('[data-dama-protect]');
  const add = target.closest('button[data-dama-cart-add]');
  const action = qty || remove || protect || add;
  if (!action) return;

  event.preventDefault();
  const root = action.closest('[data-dama-cart]');
  root?.classList.add('is-busy');

  try {
    if (qty) {
      await postCart(Theme.routes.cart_change_url, { line: Number(qty.dataset.line), quantity: Math.max(0, Number(qty.dataset.quantity)) });
    } else if (remove) {
      await postCart(Theme.routes.cart_change_url, { line: Number(remove.dataset.line), quantity: 0 });
    } else if (protect) {
      const on = protect.getAttribute('aria-checked') === 'true';
      if (on && Number(protect.dataset.line) > 0) {
        await postCart(Theme.routes.cart_change_url, { line: Number(protect.dataset.line), quantity: 0 });
      } else {
        await postCart(Theme.routes.cart_add_url, { items: [{ id: Number(protect.dataset.variantId), quantity: 1 }] });
      }
    } else if (add) {
      await postCart(Theme.routes.cart_add_url, { items: [{ id: Number(add.dataset.variantId), quantity: 1 }] });
      add.classList.add('is-added');
    }
    await refresh();
  } catch (error) {
    console.error('[dama-cart]', error);
  } finally {
    document.querySelectorAll('[data-dama-cart].is-busy').forEach((el) => el.classList.remove('is-busy'));
  }
});

initPromo();
const observer = new MutationObserver(() => initPromo());
document.addEventListener('DOMContentLoaded', () => {
  const host = document.getElementById(`shopify-section-${SECTION_ID}`);
  if (host) observer.observe(host, { childList: true, subtree: true });
  initPromo();
});
